import { Box, Grid } from "@mui/material";
import { useState, useEffect } from "react";

import ModalTrigger from "../Common/ModalTrigger";
import CustomLink from "../Common/CustomLink";
import ButtonsSelect from "../Common/ButtonsSelect";

import csv7 from "../../Data/MANCP/FoodProduct/MANCP-Comparison-of-organic-and-conventional-products-Grouped-bar-chart.csv";

import DodgeBarChart from "../Charts/DodgeBarChart";

const OrganicFoodProducts = (props) => {
  const [comparisonFilter, setComparisonFilter] = useState(0);

  const comparisonFilterHandler = (event) => {
    setComparisonFilter(event);
  };
  return (
    <Grid
      item
      container
      direction={{ xs: "column", sm: "column", md: "row" }}
      sx={{ marginTop: { xs: "50px", sm: "50px", md: "90px" } }}
    >
      <Grid
        item
        xs
        sx={{
          paddingLeft: { xs: "24px", sm: "24px", md: "24px" },
          paddingRight: { xs: "24px", sm: "45px", md: "24px" },
          paddingBottom: { xs: "24px", sm: "24px", md: "24px" },
          paddingTop: { xs: "0px", sm: "0px", md: "24px" },
        }}
        className="sever-one"
      >
        <Box sx={{ textAlign: { xs: "left", sm: "center", md: "left" } }}>
          <h3>Results for organic food products</h3>
          <p className="paragraph">
            No specific MRLs exist for organic products. The MRLs set
            in{" "}
            <CustomLink
              text=" Regulation (EC) No 396/2005"
              href="https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32005R0396&from=EN"
            />{" "}
            apply equally to organic food and to conventional food. However, Regulation (EU) No 2021/1165 authorises certain products and substances for use in organic production. Compared to conventionally produced food (non-organic), in 2023 the{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="MRL exceedances"
            />{" "}
            {/* and{' '}
						<ModalTrigger
							style={{ color: '#22294D', cursor: 'pointer' }}
							text='quantification rates'
						/>{' '} */}
            were lower in organic food for all food product categories analysed, except for animal products (1.3%).
          </p>
          <p className="paragraph">
            In 2023, 7,074 samples were labelled as organic food (excluding 477 baby food samples) and analysed, corresponding to 5.3% of the total samples, a slight decrease compared to 2022 (6.1%). Of those, 1,078 samples were reported under the{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="EU MACP"
            />
            .
          </p>
          <p className="paragraph">
            Overall, 5,663 samples flagged as organic did not contain quantifiable residues (80% vs 79% in 2022) and 1,346 samples contained quantified residues below or at the MRL level (19% vs 18.6% in 2022). Those samples reported as having residue levels above their corresponding MRLs were 65 (0.9 % vs 2.4% in 2022), of which 0.4% (25 samples) were non-compliant.
          </p>
          <p className="paragraph">
            The pesticides most frequently detected above the LOQ but below the MRL were copper
            (94.6%), bromide ion (11.3%) and chlorates (7.6%). The pesticide exceeding the MRL the most was ethylene oxide (1.4%).
          </p>
        </Box>
      </Grid>
      <Grid item xs={7} p={1}>
        <Box>
          <ButtonsSelect
            onButtonClick={comparisonFilterHandler}
            firstButton="≤MRL"
            secondButton=">MRL"
          />
        </Box>
        <Box sx={{ width: "100%" }}>
          <DodgeBarChart
            csv={csv7}
            title="Comparison of organic and conventional products"
            comparisonFilter={comparisonFilter}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default OrganicFoodProducts;
